import { useCallback, useMemo, useEffect, useState } from "react";
import isHotkey from "is-hotkey";
import { Editable, withReact, Slate } from "slate-react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";

import Toolbar from "./components/SlateToolbar";
import Element from "./elements/Element";
import Leaf from "./elements/Leaf";

import withImages from "./plugins/withImages";
import withKeyCommands from "./plugins/withKeyCommands";
import withLinks from "./plugins/withLinks";

import { toggleMark } from "./utils/Mark";

const HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
  "mod+`": "code",
};

// This component INSPIRED BY https://dev.to/koralarts/slatejs-adding-images-and-links-2g93
export default function MyEditor({
  value,
  onChange,
  readOnly,
  noBorder,
  placeholder,
}) {
  const renderElement = useCallback((props) => <Element {...props} />, []);
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);
  const editor = useMemo(
    () =>
      withKeyCommands(
        withImages(withHistory(withLinks(withReact(createEditor()))))
      ),
    []
  );
  const [myValue, setMyValue] = useState([
    { type: "paragraph", children: [{ text: "" }] },
    // {
    //   type: "paragraph",
    //   children: [
    //     { text: "asdf" },
    //     {
    //       type: "link",
    //       href: "https://google.com",
    //       children: [{ text: "asdfasd" }],
    //     },
    //   ],
    // },
  ]);

  useEffect(() => {
    // console.log(value);
    if (value && Array.isArray(value)) {
      setMyValue(value);
      editor.children = value;
    }
  }, [value]);

  const editorKeydownHandler = (event) => {
    for (const hotkey in HOTKEYS) {
      if (isHotkey(hotkey, event)) {
        event.preventDefault();
        const mark = HOTKEYS[hotkey];
        toggleMark(editor, mark);
      }
    }
  };

  return (
    <div
      style={
        noBorder
          ? {}
          : {
              paddingLeft: "20px",
              paddingRight: "20px",
              border: "1px solid #c8c8c8",
              minHeight: "300px",
              // maxHeight: '400px',
            }
      }
    >
      <Slate readOnly editor={editor} value={myValue} onChange={onChange}>
        {readOnly ? null : (
          <>
            <Toolbar />
          </>
        )}
        <Editable
          readOnly={readOnly}
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          placeholder={placeholder}
          autoFocus
          onKeyDown={editorKeydownHandler}
        />
      </Slate>
    </div>
  );
}
